export default __webpack_public_path__ + "src/images/ball/4-2793d1.png";